module.exports = __webpack_public_path__ + "static/img/HuangMu_jianjiePic_sumAndautAandWin.a19b7b4a.png";